<template>
  <v-table-wrapper
    :infinite-id="infiniteId"
    :list="list"
    :infinite-loading="infiniteLoading"
    :table-height="tableHeight"
    :with-select="isRoleAdmin"
    class="customers-table"
    v-on="$listeners"
  >
    <template #customColumns>
      <el-table-column
        prop="created_at"
        label="Добавлен"
        sortable="custom"
        class-name="customers-table__cell--date"
        min-width="124"
      >
        <template #default="{row:{dateJoined}}">
          {{ formatDate(dateJoined) }}
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="Обновлён" class-name="owners-table__cell--date" min-width="100">
        <template #default="{row:{updatedAt}}">
          {{ formatDate(updatedAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        sortable="custom"
        label="Статус"
        class-name="customers-table__cell--status"
        min-width="134"
      >
      <template #default="{ row: { workflowStatus } }">
        <v-tag
          v-if="workflowStatus"
          :custom-color="workflowStatus.color"
        >
          {{ workflowStatus.shortname || workflowStatus.name }}
          </v-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        sortable="custom"
        label="Имя покупателя"
        class-name="customers-table__cell--name"
        min-width="244"
        show-overflow-tooltip
      >
        <template #default="{row:{name, id}}">
          <v-button
            v-if="name && id"
            class="customers-table__client-link"
            is-text
            :to="{ name: 'customer-edit', params: { customerId: id } }"
            >{{ name }}</v-button
          >
          <template v-else>
            <v-button
            class="customers-table__client-link"
            is-text
            :to="{ name: 'customer-edit', params: { customerId: id } }">
              {{ name || 'Имя не указано' }}
            </v-button> </template>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="Телефон" class-name="customers-table__cell--phone" min-width="143">
        <template #default="{row:{customerProfile, phone}}">
          <!--          todo: временно убрано [phone, ...customerProfile.phones]-->
          <v-phones-popover :phones="[phone]"></v-phones-popover>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isRoleAdmin"
        prop="agent"
        sortable="custom"
        class-name="customers-table__cell--agent"
        label="Агент"
        min-width="200"
        show-overflow-tooltip
      >
        <template #default="{row:{agent}}">
          <v-agent v-if="agent" :photo="agent.photo" @click.stop>
            {{ agent.name }}
          </v-agent>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="adverts" label="Объект" class-name="customers-table__cell--advert" min-width="110">
        <template #default="{row:{adverts}}">
          <v-adverts-popover :adverts="adverts"></v-adverts-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="advert_categories"
        label="Категория"
        class-name="customers-table__cell--adverts-category"
        width="210"
      >
        <template #default="{row:{advertCategories}}">
          {{ (advertCategories && formatAdvertCategories(advertCategories)) || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="isRoleAdmin"
        prop="call_source"
        label="Источник"
        class-name="customers-table__cell--call-source"
        min-width="190"
      >
        <template #default="{row:{callSource}}">
          <div>{{ callSource.name || '-' }}</div>
        </template>
      </el-table-column>
    </template>
  </v-table-wrapper>
</template>

<script>
import VTableWrapper from '@/components/common/VTableWrapper.vue'
import VAgent from '@/components/common/VAgent.vue'
import { formatDate } from '@/utils/formatters'
import { mapGetters } from 'vuex'
import { MODULE_SESSION } from '@/store/modules/session/session.types'
import { WORKFLOW_STATUSES_GROUP_BY_ID } from '@/constants/workflowStatuses'
import VTag from '@/components/common/VTag.vue'
import VPhonesPopover from '@/components/common/VPhonesPopover.vue'
import VAdvertsPopover from '@/components/common/VAdvertsPopover.vue'
import VButton from '@/components/common/VButton.vue'

export default {
  WORKFLOW_STATUSES_GROUP_BY_ID,
  name: 'OwnersTable',
  components: {
    VButton,
    VAdvertsPopover,
    VPhonesPopover,
    VTableWrapper,
    VTag,
    VAgent
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableHeight: {
      type: Number,
      default: 500
    },
    infiniteId: {
      type: Number,
      required: true
    },
    infiniteLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isRoleAdmin: `${MODULE_SESSION}/isRoleAdmin`
    })
  },
  methods: {
    formatAdvertCategories(categories) {
      return categories.length ? categories.map(category => category.name).join(', ') : '-'
    },
    formatDate(date) {
      return formatDate(date, '.')
    }
  }
}
</script>

<style lang="scss">
.customers-table {
  &__client-link {
    color: inherit !important;

    &:hover,
    &:focus {
      color: inherit;
      text-decoration: underline;
    }
  }
}
</style>
